import React, { useMemo } from 'react'
import { HiddenContainer, Container, Box, Divider } from './styles'
import { isValidValue } from '../../../../../../../shared/utils/validates'
import { Grid } from '@material-ui/core'
import logoTmovPay from '../../../../../../../shared/assets/images/logoTmovPayGreen.svg'
import { format } from 'date-fns'
import { TextBoleto } from '../../../../PagamentoBoleto/components/DetalhePagamentoBoleto/styles'
import { colors } from '../../../../../../../shared/styles/colors'
import {
  cnpjMask,
  cpfMask,
  numberToCurrency,
} from '../../../../../../../shared/utils/formatters'
import { useCartao } from '../../../../../hooks/useCartao'
import { useComprovante } from 'modules/pagamentos/hooks/useComprovante'
import {
  getDocumento,
  getNomePessoa,
} from 'shared/utils/pessoaFisicaOrJuridica'

interface ComprovanteTransferenciaP2PProp {
  protocolo?: string
}
// eslint-disable-next-line react/display-name
const ComprovanteTransferenciaP2P = React.forwardRef<
  React.ReactElement,
  React.PropsWithChildren<ComprovanteTransferenciaP2PProp>
>((props, ref) => {
  const { transferenciaP2P } = useComprovante()
  const { cartao } = useCartao()
  const servicos = [
    'Transf entre contas TMOVPay',
    'Transf entre contas',
    'Adiandamento',
    'Saldo',
    'Estadia',
    'Reembolso de Tarifas Bancárias',
  ]

  const tituloComprovante = useMemo(() => {
    if (transferenciaP2P) {
      return servicos.includes(transferenciaP2P.descricao)
        ? 'Comprovante de transferência'
        : transferenciaP2P.descricao
    }
  }, [transferenciaP2P])

  return (
    <HiddenContainer>
      {isValidValue(transferenciaP2P) && (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Container ref={ref}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  textAlign: 'center',
                }}
              >
                <Grid item xs={12}>
                  <img alt="Logo TMOV Pay" src={logoTmovPay} height={40} />
                </Grid>
                <Grid item xs={12}>
                  <TextBoleto
                    $fontSize={'18px'}
                    $fontWeight={'700'}
                    $color={colors.gray1}
                  >
                    {tituloComprovante}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'14px'}
                    $fontWeight={'400'}
                    $color={colors.gray}
                  >
                    {format(new Date(), 'dd/MM/yyyy H:mm:ss')}
                  </TextBoleto>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                style={{
                  margin: 16,
                }}
              >
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Detalhes
                    </TextBoleto>
                  </Grid>
                </Box>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Valor
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {numberToCurrency(transferenciaP2P.valor ?? 0)}
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Tipo
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    P2P
                  </TextBoleto>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'400'}
                    $color={colors.gray7}
                  >
                    Observação
                  </TextBoleto>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <TextBoleto
                    $fontSize={'16px'}
                    $fontWeight={'600'}
                    $color={colors.gray1}
                  >
                    {transferenciaP2P.detalhe}
                  </TextBoleto>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Destino
                    </TextBoleto>
                  </Grid>
                </Box>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Favorecido
                    </TextBoleto>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {getNomePessoa(transferenciaP2P.contaDestino?.pessoa)}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Documento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {getDocumento(transferenciaP2P.contaDestino?.pessoa)
                        .length === 11
                        ? cpfMask(
                            getDocumento(transferenciaP2P.contaDestino?.pessoa),
                          )
                        : cnpjMask(
                            getDocumento(transferenciaP2P.contaDestino?.pessoa),
                          )}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'18px'}
                      $fontWeight={'700'}
                      $color={colors.gray1}
                    >
                      Pagador
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Nome
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao.titular}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      {isValidValue(cartao?.conta) ? 'Conta' : 'Cartão'}
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      {cartao?.conta ?? cartao?.identificador}
                    </TextBoleto>
                  </Grid>
                </Box>

                <Box>
                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'400'}
                      $color={colors.gray7}
                    >
                      Meio de pagamento
                    </TextBoleto>
                  </Grid>

                  <Grid item xs={12}>
                    <TextBoleto
                      $fontSize={'16px'}
                      $fontWeight={'600'}
                      $color={colors.gray1}
                    >
                      TMOV Pay
                    </TextBoleto>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </HiddenContainer>
  )
})

export default ComprovanteTransferenciaP2P
